import './style.css'
import * as THREE from 'three'
import * as dat from 'lil-gui'
import { MeshToonMaterial } from 'three'

/**
 * Debug ///////////////////////////////////////////////////////// 
 */
const gui = new dat.GUI()

const parameters = {
    materialColor: '#ffeded'
}

gui
    .addColor(parameters, 'materialColor')
    .onChange(() => {
        material.color.set(parameters.materialColor)
    })

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene ////////////////////////////////////////////////////////////////////////////////////
const scene = new THREE.Scene()

/**
 * Objects
 */

// textures ////////////////////////////////////////////////////////////////////////////////
const textureLoader = new THREE.TextureLoader();
const gradientTexture = textureLoader.load('textures/gradients/5.jpg')
gradientTexture.magFilter = THREE.NearestFilter;


const texture0 = textureLoader.load( 'textures/gradients/three.png' );
const texture1 = textureLoader.load( 'textures/gradients/socket.png' );
const texture2 = textureLoader.load( 'textures/gradients/css.jpeg' );
const texture3 = textureLoader.load( 'textures/gradients/html.png' );
const texture4 = textureLoader.load( 'textures/gradients/js.png' );
const texture5 = textureLoader.load( 'textures/gradients/node.png' );

var materials = [
    new THREE.MeshBasicMaterial( { map: texture0 } ),
    new THREE.MeshBasicMaterial( { map: texture1 } ),
    new THREE.MeshBasicMaterial( { map: texture2 } ),
    new THREE.MeshBasicMaterial( { map: texture3 } ),
    new THREE.MeshBasicMaterial( { map: texture4 } ),
    new THREE.MeshBasicMaterial( { map: texture5 } )
    ];



// materials //////////////////////////////////////////////////////////////////////////////
const WireframeMaterial = new MeshToonMaterial({ 
    color: '#ffffff',
    wireframe: true, 
    // wireframeLinewidth: 1.2,
});

const WireframeMaterialBlue = new MeshToonMaterial({ 
    color: '#94bee6',
    wireframe: true, 
    // wireframeLinewidth: 1.2,
});

const solidMaterial = new MeshToonMaterial({ 
    color: parameters.materialColor,
    gradientMap: gradientTexture, 
});


// meshes ///////////////////////////////////////////////////////////////////////////////
const mesh1 = new THREE.Mesh(
    new THREE.TorusGeometry(1, 0.89, 16, 60),
    WireframeMaterial,
);
const mesh3 = new THREE.Mesh(
    new THREE.TorusGeometry(1, 0.89, 12, 60),
    WireframeMaterial,
);
const mesh2 = new THREE.Mesh(
    new THREE.BoxGeometry(2, 2, 2, 4),
    materials,
);
    
    const sectionMeshes = [ mesh1, mesh2, mesh3 ]; 
    
    scene.add(mesh1, mesh2);
    
    // positioning objects ////////////////////////////////////////////////
    const objectsDistance = 4;
    
    mesh1.position.y = - objectsDistance * 0;
    mesh1.position.x = 2.5;
    mesh2.position.y = - objectsDistance * 1.4;
    mesh2.position.x = 2;
    mesh2.scale.set(0.6, 0.6, 0.6);
    mesh2.rotation.x = 0.25;
    mesh3.position.y = - objectsDistance * 2;
    mesh3.position.x = 0;
    // mesh3.scale.set(1.8, 1.8, 1.8);
    
    // particles /////////////////////////////////////////////////////////////
    
    // gemoetry;
    const particlesCount = 300;
    const positions = new Float32Array(particlesCount * 3);
    for(let i = 0; i < particlesCount; i ++) {
        positions[i * 3 + 0] = (Math.random() - 0.5) * 10;
        positions[i * 3 + 1] = objectsDistance * 0.5 - Math.random() * 4 * objectsDistance;
        positions[i * 3 + 2] = (Math.random() - 0.5) * 10;
    }
    
    const particleGeometry = new THREE.BufferGeometry();
    particleGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    
    // material;
    const particleMaterial = new THREE.PointsMaterial({
        color: '#ffffff',
        sizeAttenuation: true,
        size: 0.03,
    })
    
    //Points;
    const particles = new THREE.Points(particleGeometry, particleMaterial);
    scene.add(particles);
    
    //
    
    // lights ///////////////////////////////////////////////////////////////
    
    const directionalLight = new THREE.DirectionalLight('#ffffff', 1);
    directionalLight.position.set(1, 1, 0);
    scene.add(directionalLight);
    /**
     * Sizes ////////////////////////////////////////////////////////////////
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera //////////////////
 */
// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
scene.add(camera)

/**
 * Renderer /////////////////////////////////////////////////////////////
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


// scroll //////////////;
let scrollY = window.scrollY;
window.addEventListener('scroll', () => {
    scrollY = window.scrollY;
})

// cursor //////////////;
const cursor = {};
cursor.x = 0;
cursor.y = 0;

window.addEventListener('mousemove', (event) => {
    cursor.x = (event.clientX * 2 - sizes.width) / sizes.width;
    cursor.y = (event.clientY * 2 - sizes.width) / sizes.height; 
})


/**
 * Animate ////////////////////////////////////////////////////
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    mesh1.rotation.z = 0.1 * elapsedTime;
    mesh1.rotation.x = 0.08 * elapsedTime;
    // mesh2.rotation.z = 0.16 * elapsedTime;
    mesh2.rotation.y = 0.88 * elapsedTime;
    mesh2.rotation.x = 1.5 * (0.25 - Math.abs(0.5 - (0.1 * elapsedTime) % 1));
    mesh3.rotation.z = 0.4 * elapsedTime;


    // animating camera;
    const scrollPosition = - (scrollY / sizes.height) * objectsDistance;

    const parallaxX = cursor.x;
    const parallaxY = cursor.y;

    camera.position.y = scrollPosition;
    // camera.position.x = 0;
    camera.position.y += (scrollPosition + parallaxY - camera.position.y) * 0.05;
    camera.position.x += (parallaxX - camera.position.x) * 0.05;



    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

